import { defineAgenda, param } from '@/shared/navigation/core';
import { listPageViewState } from '@/shared/navigation/react/listPageViewState';

/**
 * Seznam filtrů zájezdů. `webProjectId` ve state drží scope (project select);
 * `view` je standardní ListPage záložka pohledů.
 */
export const webFilterListAgenda = defineAgenda({
  id: 'app.www.web-filters',
  path: 'app/www/web-filters',
  open: {},
  state: {
    ...listPageViewState,
    webProjectId: param.number().optional(),
  },
  title: 'Filtr zájezdů',
  icon: 'filter',
});
